import { Outlet } from 'react-router-dom'

import { Box, Button, Title } from '@factorialco/deprecated-design-system'
import { SpendingPoliciesListPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import Landing from 'modules/finance/components/SpendingPolicies/List/Landing'
import Overview from 'modules/finance/components/SpendingPolicies/List/Overview'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const SpendingPoliciesListPage = () => {
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()

  const { loading, data, error } = useQuery(SpendingPoliciesListPageDocument, {
    variables: {
      companyId: company.id.toString(),
      companyIdInt: company.id,
    },
  })

  const hasExpensePolicySettings =
    data?.features?.featuresConnection?.nodes.find(
      (feature) => feature.name === 'dev_expenses_policy_settings'
    )?.enabled ?? false

  const spendingPolicies = data?.finance?.spendingPoliciesConnection.nodes || []

  const canCreatePolicies = data?.finance?._policies.spendingPolicyCreate.can ?? false

  if (hasExpensePolicySettings) {
    return (
      <ResponsivePage.Body variant="full" showHeader={false} loading={loading} error={error}>
        <Box justifyContent="center" textAlign="center" alignItems="center" gap="s32">
          <Title
            variant="500"
            title={i18n.t('spending_policies.moved_to_settings.title')}
            description={i18n.t('spending_policies.moved_to_settings.description')}
            centered
          />
          <Button.Router to={navigation.settings.expenses.fullPath()}>
            {i18n.t('spending_policies.moved_to_settings.cta')}
          </Button.Router>
        </Box>
      </ResponsivePage.Body>
    )
  }

  return (
    <ResponsivePage.Body variant="full" showHeader={false} loading={loading} error={error}>
      {spendingPolicies.length ? (
        <Overview canCreatePolicies={canCreatePolicies} spendingPolicies={spendingPolicies} />
      ) : (
        <Landing />
      )}
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default SpendingPoliciesListPage
